import {Component, OnInit} from '@angular/core';
import {VideojsRecordComponent} from '../videojs-record/videojs-record.component';
import {Observable, Subject, Observer} from 'rxjs';
import {AgregarAccionService} from '../../../../services/api/tareas/agregar-accion/agregar-accion.service';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocationService} from '../../../../services/api/tareas/geolocalizacion/location.service';
import {StorageService} from '../../../../services/storage.service';
import {AccionesService} from '../../../../services/api/tareas/acciones/acciones.service';
import {formatDate, Location} from '@angular/common';
import videojs from 'video.js';

/*import {FormBuilder, FormGroup, Validators} from '@angular/forms';*/

@Component({
  selector: 'app-mm-video',
  templateUrl: './mm-video.component.html',
  styleUrls: ['./mm-video.component.css']
})
export class MmVideoComponent implements OnInit {

  public webcamAV: any;
  public videoRecord = VideojsRecordComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public accionService: AgregarAccionService,
    public accionesService: AccionesService,
    public locationService: LocationService,
    private storage: StorageService,
    private location: Location
  ) {
  }

  ngOnInit(): void {
    if (this.accionesService.tarea === undefined) {
      this.router.navigate(['/home']);

    } else {
      this.webcamAV = true;
      console.log('mm-video webcamAV' + this.webcamAV);
    }
  }

  send_video(): void {
    this.accionesService.calledFrom = 'mm-video';
    /*this.AccionesService.imgB64 = this.webcamImage.imageAsBase64;
    this.AccionesService.imgUrl = this.webcamImage.imageAsDataUrl;
    this.base64TrimmedURL = this.webcamImage.imageAsBase64;
    this.createBlobImageFile();*/
    // this.accionesService.multimediaData = this.webcamImage.imageData;
    // Obtener fecha hora para concatenar a la descipcion

    this.accionesService.multimedia = JSON.stringify({
      tipo: 'Video',
      campo: 'archivo'
    });
    this.router.navigate(['/agregar-accion', this.accionesService.idTarea, this.accionesService.tipoTarea]);
  }

  goToBack(): void {
    this.accionesService.destroy();
    // this.location.back();
    this.router.navigate(['/home']);
  }

}


